import { Feature } from '@yandex/ymaps3-types/packages/clusterer';

import { styles } from './UiKitPickupCluster.styles';

interface UiKitPickupClusterProps {
  features: Feature[];
  onClick: (features: Feature[]) => void;
}

export function UiKitPickupCluster({ features, onClick }: UiKitPickupClusterProps) {
  const slots = styles();

  return (
    <button
      className={slots.cluster()}
      onClick={() => onClick(features)}
    >
      <span className={slots.count()}>{features.length}</span>
    </button>
  );
}
